<template>
  <b-form-file
    ref="uploader"
    :disabled="disabled"
    :multiple="multiple"
    :state="error ? false : null"
    :value="fromValue(value)"
    @input="filesChanged(fromValue(arguments[0]))"><!--:placeholder="label"-->
  </b-form-file>
</template>
<script>
import FormFieldMixin from 'vue-forms/mixins/FormFieldMixin';
import FileFieldMixin from 'vue-forms/mixins/FileFieldMixin';

export default {
  mixins: [ FormFieldMixin, FileFieldMixin ],

  methods: {
    reset() {
      this.$refs.uploader.reset();
    }
  }
};
</script>
